import { MenuNode } from './MenuNode';
import { Helper } from './Helper';
export class ValueChangedConfirmation{
	_debug : boolean = true;
	debug(msg:string){
		if(this._debug){
			console.log("ValueChangedInformation: "+msg);
		}
	}
	
	identifier:string;
	oldValue:string;
	newValue:string;
	menuNode:MenuNode;
	// o: Old value, n: New Value, mn: MenuNode sending this confirmation
	constructor(id?:string,o?:string,n?:string,mn?:MenuNode){
		
		if(id){
			this.identifier = id;
		}
		if(o){
			this.oldValue = o;
		}
		if(n){
			this.newValue = n;
		}
		if(mn){
			this.menuNode=mn;
		}
		this.debug(this.toString());
	}
	getOldValue(){
		return this.oldValue;
	}
	getNewValue(){
		return this.newValue;
	}
	getIdentifier(){
		return this.identifier;
	}
	getMenuNode(){
		return this.menuNode;
	}
	valueChanged(){
		this.debug("was asked if i changed: "+this.toString()+" "+this.menuNode.getTargetNode().getIdentifier());
		if(this.identifier == "quickset-temperature-duration"){
			return true;
		}
		if(this.identifier == 'absenceEnd' && this.menuNode.getTargetNode().getIdentifier() == 'dashboard'){

			return true;
		}
		return this.oldValue != this.newValue;
	}
	
	getContent(){
		this.debug("ValueChangedConfirmation: "+typeof(this.newValue)+": "+this.toString());
		let nodeName = this.menuNode.getIdentifier();
		if(nodeName == "quickset-desired-flowtemp" ){
			if(parseFloat(this.newValue) == 29 && parseFloat(this.oldValue) > 29){
				return { 'text':['DELIGHT_TOAST_HEATING_OFF_1'],'icon':'iconHeatingDis'};
			}
			if(parseFloat(this.oldValue) == 29 && parseFloat(this.newValue) > 29){
				return { 'text':['DELIGHT_TOAST_HEATING_ON_1'],'icon':'iconHeating'};
			}
		}
		if(nodeName == "quickset-desired-dhw"){
			if(parseFloat(this.newValue) == 29 && parseFloat(this.oldValue) > 29){
				return { 'text':['DELIGHT_TOAST_HOTWATER_OFF_1'],'icon':'iconDomesticHotWaterDis'};
			}
			if(parseFloat(this.oldValue) == 29 && parseFloat(this.newValue) > 29){
				return { 'text':['DELIGHT_TOAST_HOTWATER_ON_1'],'icon':'iconDomesticHotWater'};
			}

		}
		if(typeof(this.newValue) == "string"){
			switch(this.newValue){
				case 'ENUM_GREEN_IQ_OFF':{
					if(this.identifier == 'comfortmode'){
						return {'text':['DELIGHT_TOAST_COMFORT_MODE_DEACTIVATED'],'icon':'iconClose'};	
					}
					return {'text':['DELIGHT_TOAST_GREEN_IQ_DEACTIVATED'],'icon':'iconClose'};
				}
				case 'ENUM_GREEN_IQ_ON':{
					if(this.identifier == 'comfortmode'){
						return {'text':['DELIGHT_TOAST_COMFORT_MODE_ACTIVATED'],'icon':'iconCheckConfirm2'};	
					}
					return {'text':['DELIGHT_TOAST_GREEN_IQ_ACTIVATED'],'icon':'iconGreenIQ'};
				}				
				
				case 'AICI_OFF_NORMAL':{
					if(this.identifier == 'smarteco_mode'){
						return {'text':['DELIGHT_TOAST_SMART_ECO_MODE_DEACTIVATED'],'icon':'iconClose'};	
					}
				}
				case 'AICI_ON_NORMAL':{
					if(this.identifier == 'smarteco_mode'){
						return {'text':['DELIGHT_TOAST_SMART_ECO_MODE_ACTIVATED'],'icon':'iconEcoMode'};	
					}
				}				
				case 'ENUM_DHW_MODE_MANUAL':{
					this.saveAnimation = true;
					return { 'text':['SPLASH_OPERATION_MODE_SAVED_MANUAL_SUBLINE'],'icon':'iconManualMode'};
				}
				case 'ENUM_COOLING_MODE_MANUAL':{
					this.saveAnimation = true;
					return { 'text':['SPLASH_OPERATION_MODE_SAVED_MANUAL_SUBLINE'],'icon':'iconManualMode'};
				}
				case 'ENUM_HEATING_MODE_MANUAL':{
					this.saveAnimation = true;
					return { 'text':['SPLASH_OPERATION_MODE_SAVED_MANUAL_SUBLINE'],'icon':'iconManualMode'};
				}
				case 'ENUM_HEATING_MODE_TIMECONTROLLED':{
					this.saveAnimation = true;
					return { 'text':['SPLASH_OPERATION_MODE_SAVED_AUTO_SUBLINE'],'icon':'iconTimeProgram'};
				}
				case 'ENUM_DHW_MODE_TIMECONTROLLED':{
					this.saveAnimation = true;
					return { 'text':['SPLASH_OPERATION_MODE_SAVED_AUTO_SUBLINE'],'icon':'iconTimeProgram'};
				}
				case 'ENUM_VENTILATION_MODE_AUTOMATIC':{
					return { 'text':['SPLASH_OPERATION_MODE_SAVED_AUTO_SUBLINE'],'icon':'iconTimeProgram'};
				}
				case 'ENUM_DHW_MODE_OFF':{
					this.saveAnimation = true;
					return { 'text':['SPLASH_OPERATION_MODE_SAVED_OFF_SUBLINE'],'icon':'iconDomesticHotWaterDis'};
				}
				case 'ENUM_COOLING_MODE_OFF':{

					return { 'text':['SPLASH_OPERATION_MODE_SAVED_OFF_SUBLINE'],'icon':'iconCheckConfirm2'};
				}
				case 'ENUM_HEATING_MODE_OFF':{
					return { 'text':['SPLASH_OPERATION_MODE_SAVED_OFF_SUBLINE'],'icon':'iconHeatingDis'};
				}
				case 'ENUM_VENTILATION_MODE_REDUCED':{
					return { 'text':['SPLASH_OPERATION_MODE_SAVED_REDUCED_SUBLINE'],'icon':'iconCheckConfirm2'};
				}
				case 'ENUM_VENTILATION_MODE_DAY':{
					return { 'text':['SPLASH_OPERATION_MODE_SAVED_NORMAL_SUBLINE'],'icon':'iconCheckConfirm2'};
				}
			}
			
			
			
			if(this.newValue == "on"){
				switch(this.identifier){
					case 'cylinder_boost':{
						return { 'text':['SPLASH_HOTWATER_BOOST_SUBLINE_1','SPLASH_HOTWATER_BOOST_SUBLINE_2'],'icon':'iconDomesticWater'};
					}
					case 'ventilation_boost':
					{
						return { 'text':['SPLASH_VENTILATION_BOOST_SUBLINE_1'],'icon':'iconVentilationBoost'};
					}
					case 'system_off':
					{
						return {'text':['SPLASH_SYSTEM_OFF_SUBLINE_1'],'icon':'iconOff2'};
					}
					case 'buttonlock':{
						return {'text':['SPLASH_KEYPAD_LOCKED_SUBLINE'],'icon':'iconLocked'};	
					}
				}
			}
			if(this.newValue == "off"){
				switch(this.identifier){
					case 'quickset-temperature-enabled':{
						return { 'text':['SPLASH_HOME_QUICK_VETO_SUBLINE_1'],'icon':'iconClose'};	
					}
					case 'cylinder_boost':{
						return { 'text':['SPLASH_HOME_CYLINDER_BOOST_SUBLINE_1'],'icon':'iconDomesticHotWaterDis'};
					}
					case 'ventilation_boost':
					{
						return { 'text':['SPLASH_HOME_VENTILATION_BOOST_SUBLINE_1'],'icon':'iconVentilation'};
					}
					case 'absenceEnd':{
						return {'text':['SPLASH_HOME_HOLIDAY_SUBLINE_1'],'icon':'iconAtHome'}
					}
					case 'system_off':
					{
						return {'text':['SPLASH_HOME_SYSTEMOFF_SUBLINE_1'],'icon':'iconStandby'};
					}
				}
			}
		}
		
		switch(this.identifier){
			case 'timeframe':{
				return {'text':['SPLASH_TIMESLOTS_SAVED_SUBLINE_1'],'icon':'iconOperationTime'};
			}
			case 'quickset-temperature-duration':{
				return {'text':['SPLASH_QUICK_VETO_SUBLINE_1'],'icon':'iconCheckConfirm2'};
			}
			case 'absenceEnd':{
						let beginDateString = 'mehmeh';
						let beginTimeString = 'meh';
						let endDateString = 'mahmah';
						let endTimeString = 'mah';
						let absenceBegin = MenuNode.ioService.deviceInfo().getDefaultZone().getDate('absenceBegin');
						let absenceEnd = MenuNode.ioService.deviceInfo().getDefaultZone().getDate('absenceEnd');
						
						endDateString = Helper.twoDigits(absenceEnd.getDate())+"."+Helper.twoDigits(absenceEnd.getMonth()+1)+"."+Helper.twoDigits(absenceEnd.getFullYear()-2000);
						endTimeString = Helper.formatTime(absenceEnd);

						beginDateString = Helper.twoDigits(absenceBegin.getDate())+"."+Helper.twoDigits(absenceBegin.getMonth()+1)+"."+Helper.twoDigits(absenceBegin.getFullYear()-2000);
						beginTimeString = Helper.formatTime(absenceBegin);

						let lineFrom=MenuNode.translator.tr("SPLASH_AWAY_CONFIRM_SUBLINE_2").replace('<joker>',beginDateString).replace('<joker>',beginTimeString);
						let lineTo=MenuNode.translator.tr("SPLASH_AWAY_CONFIRM_SUBLINE_3").replace('<joker>',endDateString).replace('<joker>',endTimeString);
						return { 'text':['SPLASH_AWAY_CONFIRM_SUBLINE_1', lineFrom, lineTo], 'icon':'iconAway'};	
			}
		}
		return { 'text':['SPLASH_GENERIC_SUBLINE_1'],'icon':'iconCheckConfirm2'};
	}

	isBlacklistedNode(){
		if(this.menuNode){
			switch(this.menuNode.getIdentifier()){
				case 'chimneysweep_dynamic':
				case 'fachhandwerker-code':{
					return true;
				}
				default:{
					return false;
				}
			}
		}
		return false;
		
	}
	isBlacklisted(){
		switch(this.identifier){
			case 'chimneysweep_dynamic_run':
			case 'zone.default.sensors.temperature.room_temperature_nominal_quick':{
				return true;
			}
			default:{

				return false;
			}
		}
	}
	saveAnimation:boolean=false;
	createSplashNode():MenuNode{
		console.log("Creating splash for "+this.menuNode.getIdentifier());
		if(this.isBlacklisted()||this.isBlacklistedNode()){
			return undefined;
		}		
		let node = new MenuNode();
		
		node.setIdentifier('splash.'+this.identifier);
		let content = this.getContent();
		node.setText(content.text);
		node.setTemplate('splash');
		node.setIcon(content.icon);
		node.setTimeout(1.5);
		node.setSplash(true);
		node.setTimeoutAction(this.menuNode.getTarget());
		if(this.saveAnimation){
			let title = "";
			if(this.menuNode.getTargetNode()){
				title = this.menuNode.getTargetNode().getTitle();
			}
			let saveAnimation = new MenuNode({
				'title':title,
				'template':'loadinganimation',
				'timeout':'1',
				'text':['AICI_SAVING'],
				'target':this.menuNode.getTarget()
			});
			saveAnimation.setSplash(true);
			node.setTimeoutAction("goto:child:0");
			node.addChild(saveAnimation);
			
		}

		this.debug("Setting target to: "+this.menuNode.getTarget());


		return node;
	}
	toString(){
		return "[id:"+this.identifier+", oldVal: "+this.oldValue+ ", newVal:" +this.newValue+ ", node: "+this.menuNode.getIdentifier() + "/" + this.menuNode.getName()+"]";
	}
}